import { render, staticRenderFns } from "./FileTypeUpload.vue?vue&type=template&id=2888a73e&scoped=true&"
import script from "./FileTypeUpload.vue?vue&type=script&lang=js&"
export * from "./FileTypeUpload.vue?vue&type=script&lang=js&"
import style0 from "./FileTypeUpload.vue?vue&type=style&index=0&id=2888a73e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2888a73e",
  null
  
)

export default component.exports